import CashbackNew from './CashbackNew';

export default CashbackNew;
